var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VideoCards"},_vm._l((_vm.listData),function(item){return _c('VideoCardsItem',{key:item.id,staticClass:"card",attrs:{"data":item,"videoId":`videoCardsItem-${item.id}`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }